import React from 'react';
import BottomNav from '../components/BottomNav';

const BullionExchange = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Bullion Exchange</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Trade Precious Metals</p>
        
        <div className="card">
          <p>
            Buy, sell, and trade gold, silver, platinum, and other precious metals. 
            Access real-time market prices and expert trading advice.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Live Trading</h3>
              <p>Real-time market access and competitive pricing</p>
            </div>
            <div className="feature-item">
              <h3>Secure Transactions</h3>
              <p>Safe and confidential precious metal trading</p>
            </div>
            <div className="feature-item">
              <h3>Expert Guidance</h3>
              <p>Professional advice on market trends and investments</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default BullionExchange;
